import React from "react";
import { MenuItemProps } from "./MenuItem";
import { useLocation } from "react-router";

const useBuildingMenu = () => {
  const location = useLocation();
  const currentPath = location.pathname.split("/")[3];

  const isMenuSelected = (menuItem: MenuItemProps) => {
    if (menuItem.path) return menuItem.path === currentPath;
    if (!menuItem.path && menuItem.subMenu) {
      const submenuSelected = menuItem?.subMenu
        .map((rec) => rec.items.map((item) => item.path))
        .flat()
        .some((path) => path === currentPath);
      return submenuSelected;
    }
    return false;
  };

  return { isMenuSelected };
};

export default useBuildingMenu;
